import React, { useEffect } from "react";
import IcecastMetadataPlayer from "icecast-metadata-player";
import ArrowDown from "../../../../../assets/icon/ArrowDown";
import InfoTrack from "./components/InfoTrack";
import ControlPlayer from "./components/ControlPlayer";
import EfirControl from "./components/EfirControl";
import Like from "../../components/Like";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/redux-hooks";
import {
  selectMainState,
  setViewRadioPlayer,
} from "../../../../../store/slices/main";

interface Props {
  cover?: string;
  metadata?: string;
  trackName?: string;
  artist?: string;
  player: IcecastMetadataPlayer;
}

const FullScreenRadioPlayer: React.FC<Props> = ({
  cover,
  metadata,
  trackName,
  artist,
  player,
}) => {
  const dispatch = useAppDispatch();
  const {
    radioPlayer: { viewPlayer, radio },
  } = useAppSelector(selectMainState);

  useEffect(() => {
    if (viewPlayer) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [viewPlayer]);

  return (
    <div className="fixed w-screen h-screen left-0 top-0 z-50 bg-[#F2F4F9]">
      <div className="w-full h-full flex flex-col items-center justify-center  px-3">
        <div className="flex flex-col items-center justify-center w-full h-[85%]">
          <InfoTrack cover={cover} trackName={trackName} artist={artist} />
          <ControlPlayer player={player} />
        </div>
        <div className="flex justify-between items-center w-full pb-14">
          <EfirControl isMetadataActive={!!radio} />
          <div className="flex items-center pr-5">
            <div className="pr-3">
              <Like />
            </div>
            <button
              onClick={() => {
                viewPlayer && dispatch(setViewRadioPlayer(false));
              }}
            >
              <ArrowDown />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullScreenRadioPlayer;
